import { organizationsForCommitmentsSelector } from "./organizationsForCommitmentsSelector";
import { RootState } from "../../../store";

export const connectedOrganizationExistsSelector = (state: RootState) => {
  const orgs = organizationsForCommitmentsSelector(state);
  return (orgs?.filter((org) => org.cloud_provider !== "gcp")?.length ?? 0) > 0;
};
